// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-dialog-panel__tool .svg-icon[data-v-8ad637e6] {\n  color: #909399 !important;\n  font-family: initial !important;\n  font-size: 14px;\n  margin-right: 8px;\n  vertical-align: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
